import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./style.css";
import ProgressBar from "react-bootstrap/ProgressBar";
import Button from "components/Button/Button";
import {
  Category_list_Api,
  HeaderConfig,
  myHeaders_Auth_With_Cache_Control,
  myHeaders_Autorized,
  user_API,
  user_entity_uuid,
} from "Api/Api";
import axios from "axios";
import EmptyMessage from "components/EmptyMessage/EmptyMessage";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { saveKey, current_unix_stamp } from "utils/Helper";

let cat_Image =
  "https://images.unsplash.com/photo-1466584241662-8cb021032c1a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80";
// eslint-disable-next-line no-unused-vars
let FavItemsSelected, newFavList;

const FavouriteModal = (props) => {
  const [Categories, set_Categories] = useState([]);
  const [loading, set_loading] = useState(false);
  const [selected_data_length, set_selected_data_length] = useState(
    props.totalFavItems.length
  );
  const [def_cat_len, set_def_cat_len] = useState(3);
  const [items_selection_left, set_items_selection_left] = useState(3);
  const [modal_loader, set_modal_loader] = useState(false);
  const [total_fav_items, set_total_fav_items] = useState([]);

  //remaining unfavoured Checkbox toggle functionality
  const onToggle = (index) => {
    let newItems = Categories.slice();
    newItems[index].checked = !newItems[index].checked;
    set_Categories(newItems);
    // modified favourite categories array
    newFavList = props.totalFavItems
      .filter((item) => !item.checked)
      .concat(Categories.filter((item) => item.checked));
    set_selected_data_length(newFavList.length);
    set_items_selection_left(def_cat_len - newFavList.length);
  };
  // Favourite categories toggle function
  const onClick = (index) => {
    let Favlist = props.totalFavItems.slice();
    Favlist[index].checked = !Favlist[index].checked;
    set_total_fav_items(Favlist);
    FavItemsSelected = JSON.stringify(
      props.totalFavItems.filter((item) => !item.checked)
    );
    // modified favourite categories array
    newFavList = props.totalFavItems
      .filter((item) => !item.checked)
      .concat(Categories.filter((item) => item.checked));

    set_selected_data_length(newFavList.length);
    set_items_selection_left(def_cat_len - newFavList.length);
  };

  useEffect(() => {
    saveKey("First_Time_Status", 0);

    axios
      .get(Category_list_Api, HeaderConfig)
      .then((response) => {
        const { totalFavItems } = props;
        const sameCat = [];
        const diffCat = [];
        let carImageProcessedTempArr = [];
        response.data.entities.forEach((item, index) => {
          if (item.image_url !== undefined) {
            let url = item.image_url;
            let array = url.split("/");
            carImageProcessedTempArr[index] = {
              created_time: item.created_time,
              description: item.description,
              entity_name: item.entity_name,
              entity_uuid: item.entity_uuid,
              friendly_url: item.friendly_url,
              image_url: `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/360x305/${array[5]}`,
              last_updated_time: item.last_updated_time,
              legacy_oid: item.legacy_oid,
            };
          } else {
            carImageProcessedTempArr[index] = {
              created_time: item.created_time,
              description: item.description,
              entity_name: item.entity_name,
              entity_uuid: item.entity_uuid,
              friendly_url: item.friendly_url,
              image_url: item.image_url,
              last_updated_time: item.last_updated_time,
              legacy_oid: item.legacy_oid,
            };
          }
        });

        carImageProcessedTempArr.forEach((el) => {
          if (totalFavItems.find((el1) => el1.entity_uuid === el.entity_uuid)) {
            sameCat.push(el);
          } else {
            diffCat.push(el);
          }
        });
        set_Categories(diffCat);
        set_loading(false);
      })
      .catch(() => {});
  }, []);

  // Code to show remaining favourite categories
  const CatListChip = () => {
    return (
      <div key={"CatListChip"} className="cat-List-Chip">
        <Row>
          {Categories.map((item, i) => (
            <Col key={i} sm={6} md={4} lg={3} className="pad0">
              <div
                key={i}
                className="listposition"
                // onChange={this.onToggle.bind(this, i)}
                onChange={() => onToggle(i)}
              >
                <p className="contenthead">{item.entity_name}</p>
                <label className="listposition">
                  <img
                    src={
                      item.image_url !== undefined || null
                        ? item.image_url
                        : cat_Image
                    }
                    alt="img"
                    className="img-fluid border-rds"
                  />
                  <div className="overlay"></div>
                  <input type="checkbox" className="checkboxposition" />
                </label>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  // Code to show empty data
  const _renderEmpty = () => {
    return <EmptyMessage empty_message="No Categories to show" />;
  };

  // Code to show Favourite category list
  const FavItems = () => {
    return (
      <div key={"FavItems"} className="cat-List-Chip">
        <Row>
          {props.totalFavItems.map((item, i) => (
            <Col key={i} sm={6} md={4} lg={3} className="pad0">
              <div
                key={i}
                className="listposition"
                onChange={onClick.bind(this, i)}
              >
                <p className="contenthead">{item.entity_name}</p>
                <label className="listposition">
                  <img
                    src={
                      item.image_url !== undefined || null
                        ? item.image_url
                        : cat_Image
                    }
                    alt="img"
                    className="img-fluid border-rds"
                  />
                  <div className="overlay"></div>
                  <input
                    type="checkbox"
                    defaultChecked
                    className="checkboxposition"
                  />
                </label>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  // Onclicking on category continue button
  const OnClickInterestedCategory = () => {
    if (newFavList !== undefined && newFavList.length !== 0) {
      const { totalFavItems } = props;
      set_modal_loader(true);
      let catTempArr = [];
      // Comparing and removing existed items when unchecked.
      const inTwoArray = [];
      const notInTwoArray = [];
      totalFavItems.forEach((el) => {
        if (newFavList.find((el1) => el1.entity_uuid === el.entity_uuid)) {
          inTwoArray.push(el);
        } else {
          notInTwoArray.push(el);
        }
      });

      notInTwoArray.forEach(function (item) {
        // user_API to delete unselected categories
        axios
          .delete(
            `${user_API}/${user_entity_uuid}/categories.audience/${item.entity_uuid}`,
            myHeaders_Autorized,
            {}
          )
          .then(() => {})
          .catch(() => {});
      });

      newFavList.forEach(function (item) {
        catTempArr.push({
          xref_data: {
            favorited_time: current_unix_stamp,
          },
          entity_uuid: item.entity_uuid,
        });
      });
      let categories_Selected = { "categories.audience": catTempArr };

      axios
        .patch(
          `${user_API}/${user_entity_uuid}`,
          JSON.stringify(categories_Selected),
          myHeaders_Autorized
        )
        .then(() => {
          set_modal_loader(false);

          // Here calling GET Fav Categories for Cache-Control: max-age=0 starts
          //axios.get(`${user_API}/${user_entity_uuid}/categories.audience?sort_obj=${encodeURIComponent('{"view_count":"asc"}')}`, myHeaders_Auth_With_Cache_Control)
          axios
            .get(
              `${user_API}/${user_entity_uuid}/categories.audience`,
              myHeaders_Auth_With_Cache_Control
            )
            .then(() => {
              window.location.reload();
            })
            .catch(() => {
              set_modal_loader(false);
            });
          // Here Calling GET Fav Categories end
        })
        .catch(() => {
          set_modal_loader(false);
        });
    } else {
      window.location.reload();
    }
  };

  return (
    <div id="Category-Personalize-Modal">
      <div className="FavouriteModal">
        {loading === true ? (
          <ActivityIndicator theme="button-Status-Loader" />
        ) : (
          <React.Fragment>
            <div className="header">
              <h2>Follow all the categories you're interested in</h2>
              <p>Click on 3 or more categories to see PKs relating to them. </p>
            </div>

            <Container>
              <div className="categories">
                {props.totalFavItems.length && Categories.length >= 0
                  ? [FavItems(), CatListChip()]
                  : CatListChip()}
              </div>
            </Container>
            <div className="modal-90w">
              <div className="footer-section">
                <Row className="Footer-Row">
                  <Col lg={8} className="">
                    <ProgressBar
                      now={
                        selected_data_length === 1
                          ? 35
                          : selected_data_length === 2
                          ? 70
                          : selected_data_length >= 3
                          ? 100
                          : ""
                      }
                    />
                  </Col>
                  <Col lg={4} className="flex-end Footer-Btn">
                    {modal_loader === false ? (
                      <Button
                        theme={
                          selected_data_length < 3
                            ? "btn-global btn-white -smoke font-small"
                            : "btn-global btn-green font-small"
                        }
                        OnClickMet={
                          selected_data_length < 3
                            ? null
                            : OnClickInterestedCategory
                        }
                      >
                        {selected_data_length < 3
                          ? `${items_selection_left} more categories to continue`
                          : "CONTINUE"}
                      </Button>
                    ) : (
                      <ActivityIndicator theme="button-Status-Loader" />
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default FavouriteModal;
